<template>
  <section style="height:100%">
    <el-row>
      <el-col :span="4" style="height:100%;position:fixed;" v-bind:style="{height: menuHeight}">
        <el-menu :default-active="activeMenu" :default-openeds="openMenus" style="height:100%;border-radius: 0 !important"
          @select="handleSelect" @open="handleOpen" @close="handleClose" theme="dark">
          <el-submenu :index="item.city" v-for="(item,index) in companies" v-bind:key="item.city">
            <template slot="title">{{item.city}}</template>
            <el-menu-item :index="c.name" v-for="c in item.companies" v-bind:key="c.id">{{c.name}}</el-menu-item>
          </el-submenu>
        </el-menu>
      </el-col>
      <el-col :span="20" style="height:100%;margin-left:16.66666667%;" v-bind:style="{height: menuHeight}" v-show="stage==1">
        <baidu-map class="bm-view" :center="center" :zoom="19" :theme="theme" ak="bAouH2hDApj3TNU7dgK02jyx">
          <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
          <!--<bm-circle :center="circlePath.center" :radius="circlePath.radius" stroke-color="red" :stroke-opacity="1"-->
          <!--:stroke-weight="4" :editing="false" :enableEditing="false" :enableClicking="false"></bm-circle>-->
          <bm-info-window :position="center" :title="title" :show="infoWindow.show" @close="infoWindowClose" @open="infoWindowOpen"
            :width="300" :closeOnClick="false" style="padding-left:20px;">
            <p class="normal-font">负责人: {{infoWindow.contact}}</p>
            <p class="normal-font">联系电话: {{infoWindow.phone}}</p>
            <p class="normal-font">
              <el-button size="small" type="info" @click="viewDeviceList">设备总数: {{infoWindow.deviceNum}}个</el-button>
            </p>
            <el-badge :value="infoWindow.warnNum" :max="99" class="tag-item">
              <el-button size="small" type="warning" @click="viewEventList(2, infoWindow.id)">预警数</el-button>
            </el-badge>
            <el-badge :value="infoWindow.errorNum" :max="99" class="tag-item">
              <el-button size="small" type="danger" @click="viewEventList(3, infoWindow.id)">告警数</el-button>
            </el-badge>
          </bm-info-window>
        </baidu-map>
      </el-col>
      <el-col :span="20" style="height:100%;margin-left:16.66666667%;padding:20px;" v-bind:style="{'margin-left': marginLeft}"
        v-show="stage==2">

        <!--工具条-->
        <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
          <el-form :inline="true" :model="filters">
            <el-form-item label="设备状态:" style="margin-left: 15px;">
              <el-radio-group v-model="filters.state">
                <el-radio :label="null">全部</el-radio>
                <el-radio :label="1">正常</el-radio>
                <el-radio :label="2">预警</el-radio>
                <el-radio :label="3">告警</el-radio>
                <el-radio :label="4">故障</el-radio>
              </el-radio-group>
            </el-form-item>
            <div style="float:right">
              <el-form-item>
                <el-button type="primary" v-on:click="getDevices">查询</el-button>
              </el-form-item>
            </div>
          </el-form>
        </el-col>

        <!--列表-->
        <el-table :data="devices" highlight-current-row border v-loading="listLoading" @row-click="rowClick" style="width: 100%;"
          ref="deviceTable" :row-class-name="tableRowClassName">
          <el-table-column header-align="center" prop="online" label="是否在线" width="100" align="center" fixed="left">
            <template scope="scope">
              <el-tag v-if="scope.row.online == null || !scope.row.online" type="gray" close-transition>{{scope.row.online
                | filterOnline}}
              </el-tag>
              <el-tag v-if="scope.row.online" type="success" close-transition>{{scope.row.online | filterOnline}}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column header-align="center" align="center" label="设备ID" width="160">
            <template scope="scope">
              {{scope.row.deviceId}}
            </template>
          </el-table-column>
          <el-table-column prop="name" header-align="center" align="center" label="设备名称">
          </el-table-column>
          <el-table-column prop="group" header-align="center" align="center" label="所属区域" width="120">
          </el-table-column>
          <el-table-column v-if="me.rname != 'ROLE_DEMO'" prop="location" header-align="center" align="center" label="设备位置">
          </el-table-column>
          <el-table-column v-if="me.rname === 'ROLE_DEMO'" header-align="center" align="center" label="设备位置">
            <template scope="scope">
              企业设备安装地址
            </template>
          </el-table-column>
          <!--<el-table-column prop="isAutoTx" :formatter="formatTx" label="自动消谐" width="100" align="center">-->
          <!--</el-table-column>-->
          <el-table-column label="当前状态" width="100" align="center">
            <template scope="scope">
              <el-tag v-if="scope.row.disconState" type="gray" close-transition>断闸
              </el-tag>
              <el-tag v-if="!scope.row.disconState && scope.row.state === 1" type="success" close-transition>{{scope.row.state
                | filterState}}
              </el-tag>
              <el-tag v-if="!scope.row.disconState && scope.row.state === 2" type="warning" close-transition>{{scope.row.state
                | filterState}}
              </el-tag>
              <el-tag v-if="!scope.row.disconState && scope.row.state === 3" type="danger" close-transition>{{scope.row.state
                | filterState}}
              </el-tag>
              <el-tag v-if="!scope.row.disconState && scope.row.state === 4" type="gray" close-transition>{{scope.row.state
                | filterState}}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column header-align="center" align="center" prop="contactPhone" label="操作" width="200">
            <template scope="scope">
              <el-button type="primary" size="small" @click="rowClick(scope.row)">查看详情</el-button>
              <el-button type="danger" :disabled="scope.row.online != 1" v-if="scope.row.canBreak && scope.row.canBreak == 1 && scope.row.disconState != 1"
                size="small" @click.stop="doOff(scope.row)">断闸</el-button>
              <el-button type="danger" :disabled="scope.row.online != 1" v-if="scope.row.disconState == 1" size="small"
                @click.stop="doOn(scope.row)">断闸复位</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!--工具条-->
        <el-col :span="24" class="toolbar">
          <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="5" :total="total"
            style="float:right;">
          </el-pagination>
        </el-col>

        <!--查看界面-->
        <el-col :span="24" v-show="deviceDetailVisible">
          <el-tabs type="border-card" class="panel">
            <el-tab-pane label="设备详情">
              <el-row type="flex" class="row-bg" :gutter="20">
                <el-col :span="14">
                  <el-row>
                    <el-col :span="12">
                      <label class="el-form-item__label label">
                        设备ID:
                      </label>
                      <label class="el-form-item__label">
                        {{selectedRow.deviceId}}
                      </label>
                    </el-col>
                    <el-col :span="12">
                      <label class="el-form-item__label label">
                        设备名称:
                      </label>
                      <label class="el-form-item__label">
                        {{selectedRow.name}}
                      </label>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <label class="el-form-item__label label">
                        设备位置:
                      </label>
                      <label v-if="me.rname != 'ROLE_DEMO'" class="el-form-item__label">
                        {{selectedRow.location}}
                      </label>
                      <label v-if="me.rname === 'ROLE_DEMO'" class="el-form-item__label">
                        企业设备安装地址
                      </label>
                    </el-col>
                    <el-col :span="12">
                      <label class="el-form-item__label label">
                        更新时间:
                      </label>
                      <label class="el-form-item__label">
                        {{selectedRow.updatedAt | filterDate}}
                      </label>
                    </el-col>
                  </el-row>
                  <!--<el-row>-->
                  <!--<el-col :span="12">-->
                  <!--<label class="el-form-item__label label">-->
                  <!--告警时间:-->
                  <!--</label>-->
                  <!--<label class="el-form-item__label">-->
                  <!--2017-06-04 19:23:44-->
                  <!--</label>-->
                  <!--</el-col>-->
                  <!--<el-col :span="12">-->
                  <!--<label class="el-form-item__label label">-->
                  <!--体检指数:-->
                  <!--</label>-->
                  <!--<el-rate style="margin-top:8px;"-->
                  <!--v-model="selectedRow.score"-->
                  <!--disabled-->
                  <!--show-text-->
                  <!--text-color="#ff9900"-->
                  <!--text-template="{value}">-->
                  <!--</el-rate>-->
                  <!--</el-col>-->
                  <!--</el-row>-->
                  <el-row>
                    <el-col :span="6">
                      <label class="el-form-item__label label">
                        当前状态:
                      </label>
                      <el-tag style="margin-top:6px;" v-if="selectedRow.disconState" type="gray" close-transition>断闸
                      </el-tag>
                      <el-tag style="margin-top:6px;" v-if="!selectedRow.disconState && selectedRow.state === 1" type="success"
                        close-transition>{{selectedRow.state | filterState}}
                      </el-tag>
                      <el-tag style="margin-top:6px;" v-if="!selectedRow.disconState && selectedRow.state === 2" type="warning"
                        close-transition>{{selectedRow.state | filterState}}
                      </el-tag>
                      <el-tag style="margin-top:6px;" v-if="!selectedRow.disconState && selectedRow.state === 3" type="danger"
                        close-transition>{{selectedRow.state | filterState}}
                      </el-tag>
                      <el-tag style="margin-top:6px;" v-if="!selectedRow.disconState && selectedRow.state === 4" type="gray"
                        close-transition>{{selectedRow.state | filterState}}
                      </el-tag>
                    </el-col>
                  </el-row>
                  <el-row style="margin-top:20px;">
                    <el-col :span="24">
                      <el-table :data="deviceDetails" border highlight-current-row height="460" v-loading="hisLoading">
                        <el-table-column header-align="center" align="center" prop="des" label="参数名" min-width="130">
                        </el-table-column>
                        <el-table-column header-align="center" align="center" label="实时值" width="120">
                          <template scope="scope">
                            {{scope.row.value}}{{scope.row.unit}}
                          </template>
                        </el-table-column>
                        <el-table-column header-align="center" align="center" prop="createdAt" :formatter="formatTime"
                          label="更新时间" width="180">
                        </el-table-column>
                        <el-table-column header-align="center" align="center" label="是否正常" width="100">
                          <template scope="scope">
                            <el-tag v-if="scope.row.state === 1" type="success" close-transition>{{scope.row.state |
                              filterState}}
                            </el-tag>
                            <el-tag v-if="scope.row.state === 2" type="warning" close-transition>{{scope.row.state |
                              filterState}}
                            </el-tag>
                            <el-tag v-if="scope.row.state === 3" type="danger" close-transition>{{scope.row.state |
                              filterState}}
                            </el-tag>
                            <el-tag v-if="scope.row.state === 4" type="gray" close-transition>{{scope.row.state |
                              filterState}}
                            </el-tag>
                          </template>
                        </el-table-column>
                      </el-table>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="10">
                  <div id="dianliuChart" class="chart"></div>
                  <div id="dianyaChart" class="chart" style="margin-top: 20px;"></div>
                </el-col>
              </el-row>
            </el-tab-pane>
          </el-tabs>
        </el-col>
      </el-col>
    </el-row>
  </section>

</template>
<style>
  html,
  body {
    margin: 0;
    padding: 0;
    height: 100%;
  }

  .bm-view {
    width: 100%;
    height: 100%;
  }

  .normal-font {
    font-size: 14px;
    color: #324057;
  }

  .tag-item {
    margin-top: 10px;
    margin-right: 25px;
  }

  .rowClass:hover {
    cursor: pointer;
  }

  .container {
    position: absolute;
    top: 0px;
    bottom: 0px;
    width: 100%;
  }

  .header {
    height: 60px;
    line-height: 60px;
    background: #324057;
    color: #fff;
  }

  div.menu-item {
    vertical-align: top;
    display: inline-block;
    text-align: center;
    width: 60px;
    height: 60px;
    margin: 0;
  }

  div.menu-item:hover {
    vertical-align: top;
    display: inline-block;
    text-align: center;
    width: 60px;
    height: 60px;
    margin: 0;
    background-color: #828282;
    cursor: pointer;
  }

  div.menu-item-actived {
    background-color: #828282;
  }

  img {
    width: 30px;
    height: 30px;
  }

  .caption {
    display: block;
    line-height: 10px;
    top: 0;
    margin-top: -16px;
    color: #ffffff;
    font-size: 12px;
  }

  .chart {
    width: 100% !important;
    height: 300px !important;
    position: relative;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    box-sizing: border-box;
  }

  .echarts {
    width: 100% !important;
    height: 300px !important;
    position: relative;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    box-sizing: border-box;
  }

</style>
<script>
  import {
    BaiduMap,
    BmInfoWindow,
    BmCircle
  } from 'vue-baidu-map'
  import echarts from 'echarts'
  import moment from 'moment'
  import {
    getCompanyGroupByCity,
    getGroupList,
    getDevicesList,
    getDeviceParamList,
    getRealtimeDataList,
    getCurDataList,
    getVolDataList,
    processOff,
    processOn,
    getCompanyStatistic
  } from '../../api/api'

  export default {
    data() {
      return {
        theme: [{
            "featureType": "all",
            "elementType": "geometry",
            "stylers": {
              "hue": "#9AC0CD",
              "saturation": 10
            }
          },
          {
            "featureType": "water",
            "elementType": "all",
            "stylers": {
              "color": "#eeeeee"
            }
          }
        ],
        infoWindow: {
          show: true,
          id: '',
          contact: '',
          phone: '',
          deviceNum: 0,
          warnNum: 0,
          errorNum: 0,
        },
        title: '<span style="color:#3fa064;font-weight: bold;font-size: 20px;padding-left:20px;">中国消防博物馆</span>',
        center: {
          lng: 116.358887,
          lat: 39.87714
        },
        circlePath: {
          center: {
            lng: 116.358887,
            lat: 39.87714
          },
          radius: 80
        },
        stage: 1,
        me: JSON.parse(sessionStorage.getItem('user')),
        deviceDetailVisible: false,
        selectedRow: {},
        params: [],
        devices: [],
        companies: [],
        points: [],
        openMenus: [],
        activeMenu: '',
        listLoading: false,
        hisLoading: false,
        page: 1,
        total: 5,
        filters: {
          state: null
        },
        menuHeight: window.innerHeight,
        marginLeft: '16.66666667%',
        selectedCompany: '',
        deviceDetails: [],
        city: ''
      }
    },
    filters: {
      filterDate(date) {
        if (date)
          return moment(date).format('YYYY-MM-DD HH:mm:ss');
      },
      filterState(state) {
        switch (state) {
          case 1:
            return '正常';
          case 2:
            return '预警';
          case 3:
            return '告警';
          case 4:
            return '故障';
          default:
            return '正常';
        }
      },
      filterOnline(state) {
        return state ? '在线' : '离线';
      },
    },
    methods: {
      formatTime: function (row, column) {
        return moment(row.createdAt).utc().format('YYYY-MM-DD HH:mm:ss');
      },
      tableRowClassName(row, index) {
        return 'rowClass';
      },
      getDevices() {
        this.deviceDetailVisible = false;
        let para = {
          page: this.page,
          size: 5,
          name: this.selectedCompany,
          state: this.filters.state
        };
        this.listLoading = true;
        //NProgress.start();
        getDevicesList(para).then((res) => {
          this.total = res.data.total;
          this.devices = res.data.list;
          this.listLoading = false;
          //NProgress.done();
        });
      },
      getDeviceParams() {
        let para = {
          deviceId: this.selectedRow.id,
        };
        //NProgress.start();
        getDeviceParamList(para).then((res) => {
          this.params = res.data;
          //NProgress.done();
        });
      },
      processData(res) {
        this.companies = res.data;

        this.$nextTick(() => {


          if (!!this.city) {
            this.openMenus.push(this.city);
            this.selectedCompany = this.$route.query.company;
          } else {
            this.openMenus.push(this.companies[0].city);
            this.city = this.companies[0].city;
            this.selectedCompany = this.companies[0].companies[0].name;
          }
          this.activeMenu = this.companies.filter(t => t.city == this.city)[0].companies[0].name

          for (var comp1 of this.companies) {
            for (var comp of comp1.companies) {
              var point = {
                key: '',
                point: {
                  lat: 0,
                  lng: 0
                },
                circlePath: {
                  center: {
                    lat: 0,
                    lng: 0
                  },
                  radius: 80
                },
                infoWindow: {
                  id: '',
                  show: true,
                  contact: '',
                  phone: '',
                  deviceNum: 0,
                  warnNum: 0,
                  errorNum: 0,
                },
                title: ''
              };
              point.key = comp.name;
              point.point.lng = comp.lng;
              point.point.lat = comp.lat;
              point.circlePath.center.lng = comp.lng;
              point.circlePath.center.lat = comp.lat;
              point.circlePath.radius = 80;
              point.infoWindow.id = comp.id;
              point.infoWindow.show = true;
              point.infoWindow.contact = comp.contactName;
              point.infoWindow.phone = comp.contactPhone;
              point.infoWindow.deviceNum = comp.deviceTotal;
              point.infoWindow.warnNum = comp.deviceWarn;
              point.infoWindow.errorNum = comp.deviceError;
              point.title = '<span style="color:#3fa064;font-weight: bold;font-size: 20px;padding-left:20px;">' +
                comp.name + '</span>';

              this.points.push(point);
            }
          }

          if (this.$route.query.company) {
            this.activeMenu = this.$route.query.company;
            //              this.handleSelect(this.$route.query.company, null);
          }

          this.infoWindow = this.points.filter(t => t.key == this.activeMenu)[0].infoWindow;
          this.center = this.points.filter(t => t.key == this.activeMenu)[0].point;
          this.circlePath = this.points.filter(t => t.key == this.activeMenu)[0].circlePath;
          this.title = this.points.filter(t => t.key == this.activeMenu)[0].title;

          this.getDevices();
        });
      },
      //获取企业列表
      getCompanies() {
        let para = {
          name: (this.me.rname === 'ROLE_PLATFORM' || this.me.rname === 'ROLE_ADMIN') ? '' : this.me.company
        };
        para.all = true;
        getCompanyGroupByCity(para).then((res) => {
          this.processData(res);
        });
      },
      formatTx: function (row, column) {
        return row.isAutoTx == 1 ? '是' : '否';
      },
      handleCurrentChange(val) {
        this.page = val;
        this.getDevices();
      },
      infoWindowClose(e) {
        //                this.infoWindow.show = false
      },
      infoWindowOpen(e) {
        this.infoWindow.show = true
      },
      viewDeviceList() {
        this.stage = 2;
      },
      viewEventList(type, companyId) {
        this.$router.push('/event?type=' + type + '&companyId=' + companyId);
      },
      handleOpen(key, keyPath) {
        //        console.log(key, keyPath);
      },
      handleClose(key, keyPath) {
        //        console.log(key, keyPath);
      },
      doOff(row) {
        this.$confirm('确认提交吗？', '提示', {}).then(() => {
          processOff(row.id).then((res) => {
            //NProgress.done();
            if (res.code == 400) {
              this.$message({
                message: res.message,
                type: 'error'
              });
              return;
            }
            this.$message({
              message: '处理成功',
              type: 'success'
            });
            this.getDevices();
          });
        });
      },
      doOn(row) {
        this.$confirm('确认提交吗？', '提示', {}).then(() => {
          processOn(row.id).then((res) => {
            //NProgress.done();
            if (res.code == 400) {
              this.$message({
                message: res.message,
                type: 'error'
              });
              return;
            }
            this.$message({
              message: '处理成功',
              type: 'success'
            });
            this.getDevices();
          });
        });
      },
      handleSelect(key, keyPath) {
        this.infoWindow.show = false;
        this.stage = 1;
        this.menuHeight = (window.innerHeight - 60) + 'px';
        this.selectedCompany = key;
        this.deviceDetailVisible = false;
        this.getDevices();

        this.points.find(t => {
          if (t.key == key) {
            this.center = t.point;
            //            this.circlePath = t.circlePath;
            this.infoWindow = t.infoWindow;
            this.title = t.title;
            console.log(this.center);
          }
        });
        setTimeout(() => {
          this.infoWindow.show = true;
        }, 100);
      },
      getHisDatas() {
        let para = {
          deviceId: this.selectedRow.id
        };
        this.hisLoading = true;
        //NProgress.start();
        getRealtimeDataList(para).then((res) => {
          this.deviceDetails = res.data;
          this.hisLoading = false;
          this.deviceDetails.map(t => {
            // todo 1拖2需要加上device地址判断
            var param = this.params.filter(f => {
              return f.paramsType == t.type;
            });

            var p = {};
            if (param.length == 1) {
              p = param[0];
            }
            if (p) {
              if (((t.type >= 5 && t.type <= 8) || (t.type >= 12 && t.type <= 15)) && parseFloat(t.value) > p.warnUp) {
                t.state = 2;
              } else if (t.type >= 20 && t.type <= 23) {
                // 功率因数
                if (parseFloat(t.value) < 0.9) {
                  t.state = 2;
                } else {
                  t.state = 1;
                }
              } else if (t.type == 30) {
                // 频率
                if (parseFloat(t.value) < 49.5 || parseFloat(t.value) > 50.5) {
                  t.state = 2;
                } else {
                  t.state = 1;
                }
              } else if (t.type == 24) {
                // 电压不平衡度
                if (parseFloat(t.value) > 5) {
                  t.state = 2;
                } else {
                  t.state = 1;
                }
              } else if (t.type == 25) {
                // 电流不平衡度
                if (parseFloat(t.value) > 30) {
                  t.state = 2;
                } else {
                  t.state = 1;
                }
              } else if (t.type >= 38 && t.type <= 52) {
                // 电压谐波含量
                if (parseFloat(t.value) > 5) {
                  t.state = 2;
                } else {
                  t.state = 1;
                }
              } else if (t.type >= 53 && t.type <= 55) {
                // 电压合格率
                if (parseFloat(t.value) > 0 && parseFloat(t.value) < 95) {
                  t.state = 2;
                } else {
                  t.state = 1;
                }
              } else if (t.type >= 56 && t.type <= 58) {
                // 电压波形失真
                if (parseFloat(t.value) > 4) {
                  t.state = 2;
                } else {
                  t.state = 1;
                }
              } else if (t.type >= 59 && t.type <= 61) {
                // 电流波形失真
                if (parseFloat(t.value) > 15) {
                  t.state = 2;
                } else {
                  t.state = 1;
                }
              } else {
                t.state = 1;
              }
            }
          });
        });
      },
      rowClick: function (row, event, column) {

        this.selectedRow = row;
        this.deviceDetailVisible = true;
        this.menuHeight = '1150px';
        this.marginLeft = '16.66666667%';

        this.deviceDetails = [];

        var device = parseInt(this.selectedRow.deviceAddr);

        this.getDeviceParams();

        setTimeout(t => {
          this.dianliuChart = echarts.init(document.getElementById('dianliuChart'));
          this.dianyaChart = echarts.init(document.getElementById('dianyaChart'));
        }, 100);

        if (row.deviceId.toUpperCase().startsWith("9")) {
          var options = {
            tooltip: {
              trigger: 'axis'
            },
            legend: {
              data: ['第1路剩余电流(mA)', '第2路剩余电流(mA)', '第3路剩余电流(mA)', '第4路剩余电流(mA)', '第5路剩余电流(mA)', '第6路剩余电流(mA)',
                '第7路剩余电流(mA)', '第8路剩余电流(mA)'
              ]
            },
            grid: {
              left: '3%',
              right: '4%',
              top: '30%',
              containLabel: true
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: []
            },
            yAxis: {
              type: 'value'
            },
            series: []
          };

          let para = {
            deviceId: this.selectedRow.id
          };
          //NProgress.start();
          getCurDataList(para).then((res) => {

            var d1 = res.data.filter(t => t.type === 101).map(t => t.value).reverse();
            var d2 = res.data.filter(t => t.type === 102).map(t => t.value).reverse();
            var d3 = res.data.filter(t => t.type === 103).map(t => t.value).reverse();
            var d4 = res.data.filter(t => t.type === 104).map(t => t.value).reverse();
            var d5 = res.data.filter(t => t.type === 105).map(t => t.value).reverse();
            var d6 = res.data.filter(t => t.type === 106).map(t => t.value).reverse();
            var d7 = res.data.filter(t => t.type === 107).map(t => t.value).reverse();
            var d8 = res.data.filter(t => t.type === 108).map(t => t.value).reverse();

            if (d1.length > 0) {
              var ser1 = {
                name: '第1路剩余电流(mA)',
                type: 'line',
                smooth: true,
                data: d1
              };
              options.series.push(ser1);

              var time = res.data.filter(t => t.type === 101).map(t => {
                return moment(t.createdAt).utc().format('HH:mm:ss');
              });
              options.xAxis.data = time.reverse();
            }

            if (d2.length > 0) {
              var ser2 = {
                name: '第2路剩余电流(mA)',
                type: 'line',
                smooth: true,
                data: d2
              };
              options.series.push(ser2);

              var time = res.data.filter(t => t.type === 102).map(t => {
                return moment(t.createdAt).utc().format('HH:mm:ss');
              });
              options.xAxis.data = time.reverse();
            }

            if (d3.length > 0) {
              var ser3 = {
                name: '第3路剩余电流(mA)',
                type: 'line',
                smooth: true,
                data: d3
              };
              options.series.push(ser3);

              var time = res.data.filter(t => t.type === 103).map(t => {
                return moment(t.createdAt).utc().format('HH:mm:ss');
              });
              options.xAxis.data = time.reverse();
            }

            if (d4.length > 0) {
              var ser4 = {
                name: '第4路剩余电流(mA)',
                type: 'line',
                smooth: true,
                data: d4
              };
              options.series.push(ser4);

              var time = res.data.filter(t => t.type === 104).map(t => {
                return moment(t.createdAt).utc().format('HH:mm:ss');
              });
              options.xAxis.data = time.reverse();
            }

            if (d5.length > 0) {
              var ser5 = {
                name: '第5路剩余电流(mA)',
                type: 'line',
                smooth: true,
                data: d5
              };
              options.series.push(ser5);

              var time = res.data.filter(t => t.type === 105).map(t => {
                return moment(t.createdAt).utc().format('HH:mm:ss');
              });
              options.xAxis.data = time.reverse();
            }

            if (d6.length > 0) {
              var ser6 = {
                name: '第6路剩余电流(mA)',
                type: 'line',
                smooth: true,
                data: d6
              };
              options.series.push(ser6);

              var time = res.data.filter(t => t.type === 106).map(t => {
                return moment(t.createdAt).utc().format('HH:mm:ss');
              });
              options.xAxis.data = time.reverse();
            }

            if (d7.length > 0) {
              var ser7 = {
                name: '第7路剩余电流(mA)',
                type: 'line',
                smooth: true,
                data: d7
              };
              options.series.push(ser7);

              var time = res.data.filter(t => t.type === 107).map(t => {
                return moment(t.createdAt).utc().format('HH:mm:ss');
              });
              options.xAxis.data = time.reverse();
            }

            if (d8.length > 0) {
              var ser8 = {
                name: '第8路剩余电流(mA)',
                type: 'line',
                smooth: true,
                data: d8
              };
              options.series.push(ser8);

              var time = res.data.filter(t => t.type === 108).map(t => {
                return moment(t.createdAt).utc().format('HH:mm:ss');
              });
              options.xAxis.data = time.reverse();
            }


            if (this.dianliuChart) {
              this.dianliuChart.clear();
              this.dianliuChart.setOption(options);
            }
          });

          var options2 = {
            tooltip: {
              trigger: 'axis'
            },
            legend: {
              data: ['第1路温度(℃)', '第2路温度(℃)', '第3路温度(℃)', '第4路温度(℃)', '第5路温度(℃)', '第6路温度(℃)', '第7路温度(℃)', '第8路温度(℃)']
            },
            grid: {
              left: '3%',
              right: '4%',
              top: '25%',
              containLabel: true
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: []
            },
            yAxis: {
              type: 'value'
            },
            series: []
          };

          getVolDataList(para).then((res) => {

            var d1 = res.data.filter(t => t.type === 201).map(t => t.value).reverse();
            var d2 = res.data.filter(t => t.type === 202).map(t => t.value).reverse();
            var d3 = res.data.filter(t => t.type === 203).map(t => t.value).reverse();
            var d4 = res.data.filter(t => t.type === 204).map(t => t.value).reverse();
            var d5 = res.data.filter(t => t.type === 205).map(t => t.value).reverse();
            var d6 = res.data.filter(t => t.type === 206).map(t => t.value).reverse();
            var d7 = res.data.filter(t => t.type === 207).map(t => t.value).reverse();
            var d8 = res.data.filter(t => t.type === 208).map(t => t.value).reverse();

            if (d1.length > 0) {
              var ser1 = {
                name: '第1路温度(℃)',
                type: 'line',
                smooth: true,
                data: d1
              };
              options2.series.push(ser1);

              var time = res.data.filter(t => t.type === 201).map(t => {
                return moment(t.createdAt).utc().format('HH:mm:ss');
              });
              options2.xAxis.data = time.reverse();
            }

            if (d2.length > 0) {
              var ser2 = {
                name: '第2路温度(℃)',
                type: 'line',
                smooth: true,
                data: d2
              };
              options2.series.push(ser2);

              var time = res.data.filter(t => t.type === 202).map(t => {
                return moment(t.createdAt).utc().format('HH:mm:ss');
              });
              options2.xAxis.data = time.reverse();
            }

            if (d3.length > 0) {
              var ser3 = {
                name: '第3路温度(℃)',
                type: 'line',
                smooth: true,
                data: d3
              };
              options2.series.push(ser3);

              var time = res.data.filter(t => t.type === 203).map(t => {
                return moment(t.createdAt).utc().format('HH:mm:ss');
              });
              options2.xAxis.data = time.reverse();
            }

            if (d4.length > 0) {
              var ser4 = {
                name: '第4路温度(℃)',
                type: 'line',
                smooth: true,
                data: d4
              };
              options2.series.push(ser4);

              var time = res.data.filter(t => t.type === 204).map(t => {
                return moment(t.createdAt).utc().format('HH:mm:ss');
              });
              options2.xAxis.data = time.reverse();
            }

            if (d5.length > 0) {
              var ser5 = {
                name: '第5路温度(℃)',
                type: 'line',
                smooth: true,
                data: d5
              };
              options2.series.push(ser5);

              var time = res.data.filter(t => t.type === 205).map(t => {
                return moment(t.createdAt).utc().format('HH:mm:ss');
              });
              options2.xAxis.data = time.reverse();
            }

            if (d6.length > 0) {
              var ser6 = {
                name: '第6路温度(℃)',
                type: 'line',
                smooth: true,
                data: d6
              };
              options2.series.push(ser6);

              var time = res.data.filter(t => t.type === 206).map(t => {
                return moment(t.createdAt).utc().format('HH:mm:ss');
              });
              options2.xAxis.data = time.reverse();
            }

            if (d7.length > 0) {
              var ser7 = {
                name: '第7路温度(℃)',
                type: 'line',
                smooth: true,
                data: d7
              };
              options2.series.push(ser7);

              var time = res.data.filter(t => t.type === 207).map(t => {
                return moment(t.createdAt).utc().format('HH:mm:ss');
              });
              options2.xAxis.data = time.reverse();
            }

            if (d8.length > 0) {
              var ser8 = {
                name: '第8路温度(℃)',
                type: 'line',
                smooth: true,
                data: d8
              };
              options2.series.push(ser8);

              var time = res.data.filter(t => t.type === 208).map(t => {
                return moment(t.createdAt).utc().format('HH:mm:ss');
              });
              options2.xAxis.data = time.reverse();
            }

            if (this.dianyaChart) {
              this.dianyaChart.clear();
              this.dianyaChart.setOption(options2);
            }
          });
        } else {
          var options = {
            tooltip: {
              trigger: 'axis'
            },
            legend: {
              data: ['A相电流(A)', 'B相电流(A)', 'C相电流(A)', '零线电流(A)']
            },
            grid: {
              left: '3%',
              right: '4%',
              top: '18%',
              containLabel: true
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
            },
            yAxis: {
              type: 'value'
            },
            series: []
          };

          let para = {
            deviceId: this.selectedRow.id
          };
          //NProgress.start();
          getCurDataList(para).then((res) => {
            var ser1 = {
              name: 'A相电流(A)',
              type: 'line',
              smooth: true,
              data: res.data.filter(t => t.type === 12).map(t => t.value).reverse()
            };
            options.series.push(ser1);

            var ser2 = {
              name: 'B相电流(A)',
              type: 'line',
              smooth: true,
              data: res.data.filter(t => t.type === 13).map(t => t.value).reverse()
            };
            options.series.push(ser2);

            var ser3 = {
              name: 'C相电流(A)',
              type: 'line',
              smooth: true,
              data: res.data.filter(t => t.type === 14).map(t => t.value).reverse()
            };
            options.series.push(ser3);

            var ser4 = {
              name: '零线电流(A)',
              type: 'line',
              smooth: true,
              data: res.data.filter(t => t.type === 15).map(t => t.value).reverse()
            };
            options.series.push(ser4);
            var time = res.data.filter(t => t.type === 12).map(t => {
              return moment(t.createdAt).utc().format('HH:mm');
            });
            options.xAxis.data = time.reverse();
            if (this.dianliuChart) {
              this.dianliuChart.clear();
              this.dianliuChart.setOption(options);
            }
          });

          var options2 = {
            tooltip: {
              trigger: 'axis'
            },
            legend: {
              data: ['第1路温度(℃)', '第2路温度(℃)', '第3路温度(℃)', '第4路温度(℃)']
            },
            grid: {
              left: '3%',
              right: '4%',
              top: '18%',
              containLabel: true
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
            },
            yAxis: {
              type: 'value'
            },
            series: []
          };

          getVolDataList(para).then((res) => {
            var ser1 = {
              name: '第1路温度(℃)',
              type: 'line',
              smooth: true,
              data: res.data.filter(t => t.type === 5).map(t => t.value).reverse()
            };
            options2.series.push(ser1);

            var ser2 = {
              name: '第2路温度(℃)',
              type: 'line',
              smooth: true,
              data: res.data.filter(t => t.type === 6).map(t => t.value).reverse()
            };
            options2.series.push(ser2);

            var ser3 = {
              name: '第3路温度(℃)',
              type: 'line',
              smooth: true,
              data: res.data.filter(t => t.type === 7).map(t => t.value).reverse()
            };
            options2.series.push(ser3);

            var ser4 = {
              name: '第4路温度(℃)',
              type: 'line',
              smooth: true,
              data: res.data.filter(t => t.type === 8).map(t => t.value).reverse()
            };
            options2.series.push(ser4);
            var time = res.data.filter(t => t.type === 5).map(t => {
              return moment(t.createdAt).utc().format('HH:mm');
            });
            options2.xAxis.data = time.reverse();
            if (this.dianyaChart) {
              this.dianyaChart.clear();
              this.dianyaChart.setOption(options2);
            }
          });
        }
        this.getHisDatas();
      },
    },
    components: {
      BaiduMap,
      BmInfoWindow,
      BmCircle
    },
    mounted: function () {
      if (this.$route.query.city) {
        this.city = this.$route.query.city;
      }
      this.getCompanies();
      this.menuHeight = (window.innerHeight - 60) + 'px';
    },
    watch: {}
  }

</script>



// WEBPACK FOOTER //
// Map.vue?514e9de6